module.exports = "/_next/static/images/down-c8b50c456d2878e792b8bca72a6bdbd4.svg";